module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f436ec45fe94644c3cfa43bc76c1ae12.png";